<template>
  <div class="column flex">
    <template
      v-for="(option, index) in options"
      :key="index"
    >
      <div class="column">
        <BaseButton
          :active="isEqual(modelValue, option)"
          active-color="secondary"
          :button-class="option.buttonClass"
          :data-intercom-target="option.dataIntercomTarget"
          :data-testid="option.dataTestId"
          :disabled="disabled || option.disabled"
          :icon="option.icon"
          :icon-class="option.iconClass"
          :icon-right="option.iconRight"
          :label="option.label"
          :label-class="option.labelClass"
          :loading="option.loading"
          menu-item
          new-design
          :new-icon="option.newIcon"
          @click="selectOption(option)"
        >
          <slot :option="option" />
        </BaseButton>
        <BaseStreemTooltip v-if="option.enableTooltip">
          {{ option.tooltipText }}
        </BaseStreemTooltip>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
export interface Option<V = string> {
  buttonClass?: string;
  dataIntercomTarget?: string;
  dataTestId?: string;
  disabled?: boolean;
  enableTooltip?: boolean;
  icon?: string;
  iconClass?: string;
  iconRight?: boolean;
  label: string;
  labelClass?: string;
  loading?: boolean;
  newIcon?: boolean;
  tooltipText?: string;
  value?: V;
}
</script>

<script setup lang="ts" generic="V, T extends Option<V>">
import { isEqual } from "lodash-es";

import { BaseButton, BaseStreemTooltip } from "shared/components/base";

interface Props {
  disabled?: boolean;
  modelValue?: T;
  options?: T[];
}

withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  options: () => [],
});

const emit = defineEmits(["update:modelValue"]);

function selectOption(option: T) {
  emit("update:modelValue", option);
}
</script>
